import { useEffect, useState } from "react";

export default function Countdown({ targetDate }) {
  const [t, setT] = useState(diff(targetDate));
  useEffect(() => {
    const i = setInterval(() => setT(diff(targetDate)), 1000 * 30);
    return () => clearInterval(i);
  }, [targetDate]);
  if (!targetDate || t.totalMs <= 0) return <span className="text-slate-500">soon</span>;
  if (t.days >= 1) return <span data-testid="countdown">in {t.days} day{t.days > 1 ? "s" : ""}</span>;
  if (t.hours >= 1) return <span data-testid="countdown">in {t.hours} hr{t.hours > 1 ? "s" : ""}</span>;
  return <span data-testid="countdown">in {t.minutes} min</span>;
}

function diff(targetDate) {
  if (!targetDate) return { totalMs: 0, days: 0, hours: 0, minutes: 0 };
  const target = new Date(targetDate + "T08:00:00").getTime();
  const totalMs = target - Date.now();
  const days = Math.max(0, Math.floor(totalMs / (1000 * 60 * 60 * 24)));
  const hours = Math.max(0, Math.floor((totalMs / (1000 * 60 * 60)) % 24));
  const minutes = Math.max(0, Math.floor((totalMs / (1000 * 60)) % 60));
  return { totalMs, days, hours, minutes };
}
